import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { PRIMARY_DUMPSTER_DISTINGUISHED_ID, ARCHIVE_DUMPSTER_DISTINGUISHED_ID } from 'owa-folders';
/**
 * Utility to check whether a folder is dumpster folder for any mailbox
 * @param folderId - the folderId.Id property of the folder
 */
export default function isDeletedItemsFolderFromAnyMailbox(folderId) {
    return (folderId &&
        (doesFolderIdEqualName(folderId, PRIMARY_DUMPSTER_DISTINGUISHED_ID) ||
            doesFolderIdEqualName(folderId, ARCHIVE_DUMPSTER_DISTINGUISHED_ID)));
}
//# sourceMappingURL=isDumpsterFolderFromAnyMailbox.js.map